import Select from "../plugins/Select";

$(document).ready(function () {
    $('[data-city-confirm]').click(function () {
        const isConfirmed = $(this).data('city-confirm') != 0;
        const city = $(this).parents('[data-city]').data('city');
        const form = $('#map-block_form');
        const formSelect = form.find('[name="city"]');

        $(this).parents('.map-block__info').slideUp(300, function () {
            $(this).remove();
        });

        formSelect.find('[selected]').removeAttr('selected');

        if (isConfirmed) {
            formSelect.find(`[value="${city}"]`).attr('selected', 'selected');
        } else {
            formSelect.find(`[value=""]`).attr('selected', 'selected');
        }

        Select.get(form).updateAll();
        formSelect.change();
    });
});